import React, { useState, startTransition } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import './CustomNavbar.css';
import { FaPhone, FaBookOpen, FaCode, FaLanguage, FaChalkboardTeacher  } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import logo from '../../assets/hansa-flex-logo.svg';
import { rewritePathForLanguage, getLocalizedSlug } from '../../lib/slugs';

function CustomNavbar() {
  const [expanded, setExpanded] = useState(false);
  const { i18n, t } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'es');
  const history = useHistory();
  const location = useLocation();

  const buildLocalizedPath = (path) => {
    const lang = (i18n.language || 'en').substring(0,2);
    const clean = path.startsWith('/') ? path : `/${path}`;
    return `/${lang}${clean}`;
  };

  const handleLanguageChange = (valueOrEvent) => {
    // react-switch calls onChange(checked:boolean)
    // other controls (like <select>) call onChange(event)
    const isBoolean = typeof valueOrEvent === 'boolean';
    const newLang = isBoolean ? (valueOrEvent ? 'es' : 'en') : valueOrEvent?.target?.value;
    if (!newLang) return;

    if (isBoolean) setChecked(valueOrEvent);

    // Rewrite URL to selected language while keeping current route
    const currentPath = location.pathname || '/';
    const stripped = currentPath.replace(/^\/(en|es)(\/|$)/i, '/');
    const localizedInner = rewritePathForLanguage(stripped, newLang);
    const newPath = `/${newLang}${localizedInner}`;

    i18n.changeLanguage(newLang);
    history.push(newPath + (location.search || '') + (location.hash || ''));
  };

  return (
    <div>
      <Navbar className="white-bg margin-left" variant="light" expand="lg" expanded={expanded}>
        <Navbar.Brand as={Link} to={buildLocalizedPath('/') }>
          <img src={logo} className="d-inline-block align-top custom-nav-logo" alt="HANSA-FLEX" />
        </Navbar.Brand>
        <div className="custom-nav-menu">
          <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)} />
          <div className="left-align-items">
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="c-nav-menu">
                <Nav.Link as={Link} to={`/${(i18n.language||'en').substring(0,2)}${getLocalizedSlug('contact_us', i18n.language)}`}>
                  <FaLocationDot /> {t('Branch finder')}
                </Nav.Link>
                <Nav.Link as={Link} to={`/${(i18n.language||'en').substring(0,2)}${getLocalizedSlug('contact', i18n.language)}`}>
                  <FaChalkboardTeacher  /> {t('Get a quote')}
                </Nav.Link>
                <Nav.Link href="#">
                  <div className='d-flex justify-content-center align-items-center'>
                    <FaLanguage /><span className={`language-label ${!checked ? 'active' : ''}`}>En </span>
                    <Switch
                      checked={checked}
                      onChange={handleLanguageChange}
                      onColor="#4CAF50"
                      offColor="#FF5722"
                      onHandleColor="#fff"
                      offHandleColor="#fff"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={22}
                      width={48}
                      className="language-switch ms-1 me-1"
                    />
                    <span className={`language-label ${checked ? 'active' : ''}`}> Es</span>
                  </div>
                </Nav.Link>
                <Nav.Link href="https://shop.hansa-flex.es/" target="_blank" rel="noopener noreferrer">
                  <FaBookOpen /> {t('Online Catalogue')}
                </Nav.Link>
                <Nav.Link href="https://my.hansa-flex.es/es_ES/login" target="_blank" rel="noopener noreferrer">
                  <FaCode /> {t('X-CODE Manager')}
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    </div>
  );
}

export default CustomNavbar;
